import React from 'react';
import AppShowcasePage from './AppShowcasePage';
import { appShowcases } from '../content/appShowcases';

export default function Shopping4Chow() {
  return <AppShowcasePage slug="shopping-4-chow" content={appShowcases['shopping-4-chow']} />;
}
